<template>
    <vx-table class="xl:grid-cols-8-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Campaign ID</div>
            <div>Source</div>
            <div>Brand</div>
            <div>Use Case</div>
            <div>Status</div>
            <div>Class</div>
            <div>Numbers</div>
            <div>Synced</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
